export default __webpack_public_path__ + "static/media/comingSoon.252158d4.gif";